import {CompleteInspectionPage} from '../modules/CompleteInspection';

export default CompleteInspectionPage
